import React from 'react';

import { StudyOptionTemplateMultiSelect } from 'components/pages/ModeReports/ModeReportsFilters/StudyOptionTemplateMultiSelect';

import ReportMultiSelectBase from './ReportMultiSelectBase';

import './ReportStudyPcnMultiSelectFilter.scss';

const ReportStudyPcnMultiSelectFilter = ({ setOptionsAsFavorite, favoriteOptions, ...rest }) => {
  const customFilterFunction = function(e, index, collection, searchString) {
    const searchLower = (searchString || '').toLowerCase();
    return `${e.pcn} ${e.name}`.toLowerCase().includes(searchLower);
  };

  const customOptionTemplateFunction = option => (
    <StudyOptionTemplateMultiSelect
      favoriteOptions={favoriteOptions}
      option={option}
      setOptionsAsFavorite={setOptionsAsFavorite}
    />
  );

  return (
    <ReportMultiSelectBase
      {...rest}
      className="study-pcn-multiselect-filter"
      favoriteOptions={favoriteOptions}
      setOptionsAsFavorite={setOptionsAsFavorite}
      customFilterFunction={customFilterFunction}
      customOptionTemplateFunction={customOptionTemplateFunction}
    />
  );
};

export default ReportStudyPcnMultiSelectFilter;
